import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  convertStraight,
  formattedAmount,
  formattedLongDate2,
} from "../../components/common-data/Converts";
import CommonTable from "../../components/common-components/common-tables/CommonTable";
import { selectUser } from "../../components/auth/auth.selector";
import {
  CalendarIcon,
  CallIcon,
  ClockIconV3,
  DownloadIcon,
  EmailIcon,
  LocationIcon1,
  PersonIcon,
} from "../../images/icons/icons";

const OneDayMembershipSubscriptions = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setViewImage,
  setImageModal,
}) => {
  const { oneDayPlansData, oneDayPlansLoading, oneDayPlansError } = useSelector(
    (state) => state.plans
  );
  const decryptedText = useSelector(selectUser);
  const isAdmin = decryptedText?.account_type === "admin";

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      !oneDayPlansLoading &&
      !oneDayPlansError &&
      oneDayPlansData?.status &&
      oneDayPlansData?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: oneDayPlansData.data,
        pagination:
          oneDayPlansData?.pagination?.length > 0
            ? oneDayPlansData.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [oneDayPlansLoading, oneDayPlansError, oneDayPlansData]);

  // const tbColumn = [
  //   {
  //     dataField: "details_user",
  //     text: "member Details",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="emeberDetailsRowContainer">
  //           <img
  //             src={row?.profile || BodyBuilder}
  //             alt={row?.user_name || "NA"}
  //             className="image"
  //             onClick={() => {
  //               setViewImage(row?.profile || BodyBuilder);
  //               setImageModal(true);
  //             }}
  //           />

  //           <div className="flexColumn">
  //             <span className="tb-data" style={{ textAlign: "start" }}>
  //               {row?.user_name || "NA"}
  //               <br />
  //               <small className="underline lowercase">
  //                 {row?.user_mobile || ""}
  //                 <br />
  //                 {row?.user_email || ""}
  //               </small>
  //             </span>
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
  //           <small>{row?.gym_name || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "source_name",
  //     text: "Source Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth90">
  //           {row?.source_name?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "date_added",
  //     text: "Subs Start/Expire Date",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth100">
  //           <small className="gray underline">
  //             {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
  //           </small>
  //           <br />
  //           {row?.start_date ? convertStraight(row.start_date) : "-"}
  //           <br />/{row?.expire_date ? convertStraight(row.expire_date) : "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "subscription_status",
  //     text: "Subs Status",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data withPadding borderRdius8 minWidth150"
  //           style={{
  //             background:
  //               row?.subscription_status === "active" ? "#379C00" : "#C90808",
  //             color: "#fff",
  //           }}
  //         >
  //           <small>{row?.subscription_status || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "checkout_source",
  //     text: "Checkout Source",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.checkout_source?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gender",
  //     text: "Gender",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}{" "}
  //           <br />
  //           {row?.gender || "-"}
  //         </span>
  //       );
  //     },
  //   },
  // ];

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_name || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_mobile || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span className="tb-data lowercase">
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 25;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.one_day_membership
                ? "One Day"
                : row?.type === "addon_pt"
                ? "PT"
                : row?.type?.replace(/_/g, " ") || "NA"}
            </span>

            <span className="tb-data">
              {" "}
              {row?.type === "regular"
                ? row?.plan_name
                : row?.addon_name || "NA"}{" "}
              @₹{row?.price ? formattedAmount(row.price) : 0}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subs Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.subscription_status === "active"
                ? "tb-badge-success"
                : "tb-badge-stuck"
            }`}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "transaction ID",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.is_imported === 1
                ? "Import Member"
                : row?.trx_id === "cash"
                ? "Cash"
                : `Online/${row?.trx_id}` || "NA"}
            </span>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <LocationIcon1 />
              </span>{" "}
              <span className="tb-data">
                {row.payment_location === "gym" ? "Inside Gym" : "Outside Gym"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "subscription_added",
      text: "Add Date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 />
            </span>{" "}
            <span className="tb-data">
              {row?.date_added ? formattedLongDate2(row.date_added) : "-"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.start_date ? convertStraight(row.start_date) : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.expire_date ? convertStraight(row.expire_date) : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Checkout Source",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {" "}
            {row?.checkout_source?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Gender",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}{" "}
            {row?.gender || "NA"}
          </span>
        );
      },
    },
    ...(isAdmin
      ? [
          {
            dataField: "actions",
            text: "Actions",
            formatter: (_, row) => {
              return (
                <div className="pp-employee-payroll-actions">
                  <button
                    key="available-trainers"
                    type="button"
                    className={`pp-employee-payroll-action-button pp-outlined-border ${
                      !row?.invoice_link ? "disabled" : ""
                    }`}
                    onClick={() => {
                      if (row?.invoice_link) {
                        window.open(row.invoice_link, "_blank");
                      } else return;
                    }}
                    disabled={!row?.invoice_link}
                  >
                    <DownloadIcon color="#000" />
                    invoice
                  </button>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="common-table-container tb-bordered mt15">
        <CommonTable
          tableData={allDatas.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={oneDayPlansLoading}
        />
      </div>

      {/* <div className="subscriptionTbContainer" style={{ marginTop: "20px" }}>
        {oneDayPlansLoading ? (
          <TableSkeleton columns={9} rows={5} />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumn}
            isPage={isPage}
            setIsPage={setIsPage}
            tablePagination={allDatas.pagination}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div> */}
    </>
  );
};

export default OneDayMembershipSubscriptions;
